export enum AccountType {
  ADMIN = "admin",
  BRAND = "brand",
  CREATOR = "creator",
  EPHEMERAL = "ephemeral",
  VENDOR = "vendor",
}
